import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { MapPin } from "lucide-react";
import { COUNTRIES } from "@/data/countries";

export const Coverage = () => (
  <section id="coverage" data-testid="coverage-section" className="py-24 md:py-32 px-6 md:px-12">
    <div className="max-w-[1600px] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
        <Reveal className="lg:col-span-8">
          <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">
            Europe coverage
          </p>
          <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl xl:text-8xl">
            Recruitment projects
            <br />
            across Europe.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4">
          <p className="font-body text-[#52525b] leading-relaxed">
            Countries where we currently run active or verified recruitment projects. Tap a
            country to see its dedicated page and live vacancies.
          </p>
        </Reveal>
      </div>

      <div className="flex flex-wrap gap-3">
        {COUNTRIES.map((c, i) => (
          <Reveal key={c.slug} delay={i * 0.03}>
            <Link
              to={`/country/${c.slug}`}
              data-testid={`country-${i}`}
              className="group inline-flex items-center gap-2 border border-[#e4e4e7] hover:border-[#ff3b30] hover:bg-[#f5f5f4] px-5 py-3 font-head uppercase tracking-tight text-lg transition-colors duration-300"
            >
              <MapPin size={15} className="text-[#ff3b30]" />
              {c.name}
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
